import gql from 'graphql-tag';

import { getSingleProp, unwrapEdges } from 'src/utils/lib/graphql';
import apolloClient from 'src/store/client';
import { PerformanceCenterTextVariationsResult } from './schema';

const QUERY = gql`
  query PerformanceCenterTextVariationsConnectedRequests(
    $dataSource: String!
    $workspaceId: ID!
    $textVariationsResultsCount: Int!
  ) {
    me {
      id
      performanceCenterTextVariationsConnectedRequests(
        dataSource: $dataSource
        workspaceId: $workspaceId
      ) {
        id
        accountIds
        assetType
        insightsIntervalDays
        updatedAt
        campaigns {
          id
          name
        }
        performanceCenterTextVariationsResults(first: $textVariationsResultsCount) {
          edges {
            node {
              ...PerformanceCenterTextVariationsResult
            }
          }
        }
      }
    }
  }
  ${PerformanceCenterTextVariationsResult}
`;

export const queryPerformanceCenterTextVariationsConnectedRequests = (
  dataSource,
  workspaceId,
  textVariationsResultsCount = 50000
) => {
  return apolloClient
    .query({
      query: QUERY,
      variables: {
        dataSource,
        workspaceId,
        textVariationsResultsCount,
      },
      fetchPolicy: 'network-only',
    })
    .then(({ data }) => getSingleProp(data))
    .then((result) => {
      return result?.performanceCenterTextVariationsConnectedRequests.map(
        (performanceCenterTextVariationsConnectedRequest) => {
          const copies = unwrapEdges(
            performanceCenterTextVariationsConnectedRequest?.performanceCenterTextVariationsResults
              ?.edges || []
          );

          const accountIds = performanceCenterTextVariationsConnectedRequest?.accountIds || [];
          const filterAssetType =
            performanceCenterTextVariationsConnectedRequest?.assetType || null;

          return {
            copies,
            accountIds,
            filterAssetType,
            ...performanceCenterTextVariationsConnectedRequest,
          };
        }
      );
    });
};
